export const placeHolder = {
	en: "Search by country name, currency name or currency Code",
	ko: "국가 이름, 통화 이름 또는 통화 코드로 검색",
	zh: "按国家名称、货币名称或货币代码搜索",
};